


















import { Component, Prop, Emit } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'

@Component({
  components: {}
})
export default class SearchResultPagination extends ComponentVue {
  @Prop({
    type: Number,
    default: 0
  })
  total!: number

  @Prop({
    type: Number,
    default: 0
  })
  currentPage!: number

  @Prop({
    type: Boolean,
    default: false
  })
  disabled!: boolean

  get disabledPrev(): boolean {
    return this.currentPage < 2 || this.disabled
  }

  get disabledNext(): boolean {
    return this.currentPage === this.total || this.disabled
  }

  @Emit('prev')
  prev(): void {}

  @Emit('next')
  next(): void {}
}
